//
import Model from '@/models/Model'

/**
 * This class describes a service.
 *
 * @class      Service (name)
 */
export default class Service {

  /**
   * Appends & includes of model request.
   */
  appends = []
  includes = []

  /**
   * { function_description }
   *
   * @param      {Array}  options  The options
   */
  append(...options) {
    
    //
    this.appends = [...options]

    //
    return this
  }

  /**
   * Fetches the given options.
   *
   * @param      {Object}  [options={}]  The options
   * @return     {Promise} The fetch (get) model data promise
   */
  fetch(options = {}) {
    return this
      .resource()
      .append(this.appends)
      .include(this.includes)
      .params({})
      .get()
  }

  /**
   * Fetches a data table.
   *
   * @param      {Function}  limit        The limit
   * @param      {Function}  page         The page
   * @param      {<type>}    sort         The sort
   * @param      {Function}  [params={}]  The parameters
   * @return     {<type>}    The data table.
   */
  fetchDataTable(limit, page, sort, params = {}) {
    return this
      .resource()
      .append(this.appends)
      .include(this.includes)
      .limit(limit)
      .page(page)
      .orderBy(sort)
      .params(params)
      .get()
  }

  /**
   * { function_description }
   *
   * @param      {<type>}            error          The error
   * @param      {(Array|string[])}  [messages=[]]  The messages
   * @return     {Promise}           { description_of_the_return_value }
   */
  static async errorify(error, messages = []) {

    //
    console.log({ error })

    //
    const errorData = (error && error.response && error.response.data) || {}
    const hasError = errorData.hasOwnProperty('error')
    const hasErrors = errorData.hasOwnProperty('errors')

    //
    if (hasError) messages.push(errorData.error)

    //
    if (hasErrors) {

      //
      const errors = errorData.errors
      const errorsKeys = Object.keys(errorData.errors)
      const model = this().resource()

      //
      errorsKeys.forEach( key => {
        errors[ key ].forEach( message => {

          //
          let text = [ model.errors[ key ] ? model.errors[ key ].name : key, message ].join(': ')

          //
          if ( model.errors[ key ] ) {
            model.errors[ key ].translates.forEach( item => {
              text = text.replace( item.translate, item.value )
            })
          }

          // 
          if ( model.errors[ "_default" ] ) {
            model.errors[ "_default" ].translates.forEach( item => {
              text = text.replace( item.translate, item.value )
            })
          }

          //
          messages.push(text)
        })
      })
    }

    //
    return messages.join('\n')
  }

  /**
   * { function_description }
   *
   * @param      {Array}  options  The options
   */
  include(...options) {

    //
    this.includes = [...options]

    //
    return this
  }

  /**
   * { function_description }
   *
   * @return     {<type>}  { description_of_the_return_value }
   */
  static model() {
    return new this().resource()
  }

  /**
   * Return the model resource of current service.
   *
   * @return     {Object}  The model resource
   */
  resource() {
    return Model
  }

  /**
   * Returns a list representation of the service.
   *
   * @return     {Object}  List representation of the service.
   */
  toList() {
    return this
      .append('')
      .include('')
  }
}
